<script setup lang="ts">
import { getCategories } from '../../composables/getCategories';
import HomeLayout from "~/layouts/HomeLayout.vue"
import { SUPPORTED_PAGES_ENUM } from "~/common/breadCrumbs"
import BlogsNotFound from "~/components/BlogsNotFound.vue"
import type { Post } from '~/models/Post';
/**
 *
 *  Props and emits section
 *
 *
 */
// definePageMeta({
//     layout: "store-layout",
// })
/**
 *
 *  Ref, computed and hooks section
 *
 *
 */
useSeoMeta({
    title: 'Blog',
    ogTitle: 'Blog - Dapamas',
    description: 'Artículos, novedades y consejos de Dapamas.',
    ogDescription: 'Artículos, novedades y consejos de Dapamas.',
})

const $q = useQuasar()

const notify = useNotification()
const storeTypeStore = useStoreTypeStore()
const route = useRoute()
const search = ref('')
const categories = ref(route.query.categories ?? undefined)

const router = useRouter()
const {
    page,
    paginator,
    qTablePaginatorConnector,
    loading,
    clearAllFilters,
    addFilter,
    handlePaginate,
} = usePagination<Post>("public/posts", "GET", undefined, [], 6)

const pages = computed(() => {
    const rowsPerPage = paginator.value.per_page

    const rows = paginator.value.total
    let result = rows / rowsPerPage
    const rest = rows % rowsPerPage
    if (rest > 0) {
        result++
        return result
    } else return result
})

const filters = ref<{
    name?: string
}>({
    name: route.params.name as string,
})
/**
 *
 *  Life cicle events
 *
 *
*/
watch(()=>route,(newValue)=>{
        const categories = newValue.query.categories ?? undefined
        if(categories){
            addFilter('categories[]',categories)
            handlePaginate()
        }
},{
    immediate:true,
    deep:true
})

watch(search,(newValue)=>{
        if(newValue){
            addFilter('name',newValue)
            handlePaginate()
        }
},{
    immediate:true,
    deep:true
})

/**
 *
 *  Functions section
 *
 *
 */

 onMounted(() => {
    handlePaginate()
})
</script>

<template>
    <HomeLayout
        :title="$t('home.blog')"
        :currentPage="SUPPORTED_PAGES_ENUM.Blog"
        withoutSteps
        withoutParentStyles
        withoutBanner
    >
        <div class="max-container tw-grid tw-grid-cols-12 tw-gap-3 tw-min-h-screen tw-mt-10">
            <div class="tw-col-span-12 md:tw-col-span-8 lg:tw-col-span-9">
                <div class="home-nav-px lg:!tw-pl-0">
                    <BlogsNotFound v-if="qTablePaginatorConnector.items.length == 0 && !loading" />
                    <div v-if="loading" class="tw-grid tw-grid-cols-12 tw-gap-4" id="posts">
                        <ProductCardSkeleton
                            class="tw-col-span-12 sm:tw-col-span-6 md:tw-col-span-6 lg:tw-col-span-3 xl:tw-col-span-3"
                            v-show="loading" v-for="index in 6" :key="index" />
                    </div>
                    <div v-else class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-3 tw-gap-4 tw-p-2">
                        <CardPublicPost
                            class=""
                            :post="post" :key="post.id" v-for="post in qTablePaginatorConnector.items" />
                    </div>

                    <div class="tw-flex tw-justify-center tw-my-5" v-if="qTablePaginatorConnector.items.length > 0">
                        <q-pagination :max="pages" v-model="page" flat direction-links max-pages="6" boundary-numbers
                            @update:model-value="() => handlePaginate()" />
                    </div>
                </div>
            </div>
            <div class="md:tw-col-span-4 lg:tw-col-span-3 tw-hidden md:tw-flex">
                <div class="tw-w-full tw-flex tw-flex-col tw-gap-4 home-nav-px lg:!tw-pl-0">
                    <p class="tw-text-sm tw-font-[500] tw-text-primary"> {{ $t('fields.search_posts') }}</p>
                    <InputSearch v-model:search="search" />
                    <DividirWithLabel :label="$t('fields.category')" />
                    <BlogCategories />
                    <DividirWithLabel :label="$t('fields.tag')" />
                    <BlogKeywords />
                </div> 
            </div>
        </div>
    </HomeLayout>
</template>

<style scoped></style>
